import React from 'react'
import { Accordion, Button, Segment, Label, List } from 'semantic-ui-react'

const panels = [
  {
    title: 'Filters',
    content: {
      content: (
        <div>
          <Segment basic compact>
            <div>
              <span>Budget </span>
              <br />
              <Button.Group basic size="tiny">
                <Button>Bootstrapped</Button>
                <Button>Startup</Button>
                <Button>Enterprise</Button>
              </Button.Group>
            </div>
            <br />
            <div>
              <span>Sector </span>
              <br />
              <Button.Group basic size="tiny">
                <Button>Saas</Button> <Button>Mobile</Button>{' '}
                <Button>Ecommerce</Button> <Button>Retail</Button>
              </Button.Group>
            </div>
            <br />
            <div>
              <br />
              <Button basic color="red" size="mini">
                Clear
              </Button>
            </div>
          </Segment>
        </div>
      ),
      key: 'filters',
    },
  },
]

const Productfilters = () => (
  <div style={{ maxWidth: '1000px', textAlign: 'right' }}>
    <Label basic>
      <Accordion panels={panels} />
    </Label>
  </div>
)
export default Productfilters



// WEBPACK FOOTER //
// ./src/components/productfilters.js